var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 0.349953C9.16099 0.349953 10.9128 2.45625 10.9128 5.0545V8.81813C10.9128 11.4164 9.16099 13.5227 7.00004 13.5227C4.83904 13.5227 3.08724 11.4164 3.08724 8.81813V5.0545C3.08724 2.45625 4.83904 0.349953 7.00004 0.349953ZM0 9.75904H1.5776C1.95732 12.9509 4.24035 15.4045 7.00004 15.4045C9.75965 15.4045 12.0427 12.9509 12.4224 9.75904H14C13.6392 13.6841 11.0471 16.8007 7.7826 17.2347V21.0499H6.21749V17.2347C2.95293 16.8007 0.360875 13.6841 0 9.75904Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.3409b512bc527c24ef2999c506d719f9.svg";
export { ForwardRef as ReactComponent };